import { useDebouncedEffect } from "@react-hookz/web";
import { useState } from "react";

export interface UseDebouncedSearchResult {
    search: string;
    debouncedSearch: string;
    setSearch: (value: string) => void;
    clear: () => void;
}

export function useDebouncedSearch(): UseDebouncedSearchResult {
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    // Waits 250ms idle, fires at most every 1000ms while typing continuously
    useDebouncedEffect(() => setDebouncedSearch(search), [search], 250, 1000);

    const clear = () => {
        setSearch("");
        setDebouncedSearch("");
    };

    return { search, debouncedSearch, setSearch, clear };
}
